var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRentArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103 18",
    width: 103,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rent-arrow-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #f5a16f } \n\t\t.s1 { fill: #5796d2;stroke: #196faf } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0.7 9.2l90.7-4.5v8.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m102.2 9.2c0 4.5-3.6 8.1-8.1 8.1-4.5 0-8.1-3.6-8.1-8.1 0-4.5 3.6-8.1 8.1-8.1 4.5 0 8.1 3.6 8.1 8.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentArrow);
export default __webpack_public_path__ + "static/media/rent-arrow.6ac4c432a3732712077639b7b58094d4.svg";
export { ForwardRef as ReactComponent };